<template>
  <div :class="[$style['store__content'], { 'store__content--small': small }]">
    <h3 class="h-margin-bottom-s">
      {{ $t('openinghours/title') }}
    </h3>
    <table class="no-border compact">
      <tbody>
        <tr
          v-for="row in store.openingHours"
          :key="row.day"
          class="h-margin-top">
          <td>{{ row.title }}</td>
          <td
            class="align-right"
            :class="
              row.nonRegularHours ? $style['store__content__time--highlight'] : ''
            ">
            {{ row.time }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
defineProps({
  store: {
    type: [Array, Object],
    default: null
  },
  small: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" module>
.store__content {
  &--small {
    h3 {
      font-size: $font-size-m;
      margin-bottom: 0;
    }

    table {
      font-size: $font-size-xs;
    }
  }

  &__time {
    &--highlight {
      font-weight: bold;
    }
  }
}
</style>
